import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { FormeJuridiqueDto } from 'src/api/models';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-formes-juridiques-cell',
  templateUrl: './formes-juridiques.component.html',
  styleUrls: ['./formes-juridiques.component.css']
})
export class FormesJuridiquesCellComponent implements OnInit, OnDestroy {
  @Select(ControlPanelStore.formesJuridiques$) formesJuridiques$: Observable<FormeJuridiqueDto[]>;

  @Input() formeJuridiqueId: number;
  public FormeJuridiqueInComponent: FormeJuridiqueDto;

  private fj: Subscription;

  constructor() { }

  ngOnInit(): void {
    this.fj = this.formesJuridiques$.subscribe(res => {
      if (res != null) {
        let formesJuridiques = res.filter(p => p.Id == this.formeJuridiqueId);
        this.FormeJuridiqueInComponent = formesJuridiques.length == 1 ? formesJuridiques[0] : { Identifiant: null };
      }
    });
  }
  ngOnDestroy() {
    this.fj?.unsubscribe();
  }


}
